module.exports = __webpack_public_path__ + "static/sc-note-f28840c55698b0a9c10e74430084987d.png";